import React, {useState} from 'react'
import {BrowserRouter, Route, Switch} from "react-router-dom";
import Header from "./Headers/Header";
import {default as Links} from "../Route";
import Home from "./Body/Home";
import Directory from "./Body/Directory";
import Components from "../components";
import Association from "./Body/Association";
import Activities from "./Body/Activities";
import News from "./Body/News";
import Contact from "./Body/Contact";
import Forum from "./Body/Forum";
import Join from "./Body/Join";
import SignIn from "./Body/Auth/SignIn";
import Logout from "./Body/Auth/Logout";
import Footer from "./Footers/Footer";
import Proof from "./Body/Proof";
import AuthenticationAPI from "../services/AuthenticationAPI";
import AuthenticationContext from "../services/AuthenticationContext";
import AuthenticatedRoute from "../services/AuthenticatedRoute";
import Administration from "./Body/Admin";
import MemberProfile from "./Body/MemberProfile";
import PaySession from "./Body/PaySession";
import PasswordForgotten from "./Body/Auth/PasswordForgotten";

export default function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(AuthenticationAPI.isAuthenticated());
    return (
        <AuthenticationContext.Provider value={{isAuthenticated, setIsAuthenticated}}>
            <BrowserRouter>
                <Header />
                <Switch>
                    <Route exact path={Links.Home.link} component={Home} />
                    <Route exact path={Links.Association.link} component={Association} />
                    <Route exact path={Links.Activities.link} component={Activities} />
                    <Route exact path={Links.Directory.link} component={Directory} />
                    <Route exact path={Links.News.link} component={News} />
                    <Route exact path={Links.Forum.link} component={Forum} />
                    <Route exact path={Links.Contact.link} component={Contact} />
                    <Route exact path={Links.Join.link} component={Join} />
                    <Route exact path={Links.SignIn.link} component={SignIn} />
                    <Route exact path={Links.Logout.link} component={Logout} />
                    <Route exact path={Links.PasswordForgotten.link} component={PasswordForgotten} />
                    <Route exact path={Links.Proof.link} render={({match}) => {
                        return <Proof {...match.params} />
                    }}/>
                    <Route exact path={Links.PaySession.link} render={({match}) => {
                        return <PaySession {...match.params} />
                    }}/>
                    <Route exact path={Links.PaySessionSuccessful.link} render={({match}) => {
                        const params = match.params;
                        params.link = Links.PaySessionSuccessful.link;
                        return <PaySession {...params} />
                    }}/>
                    <AuthenticatedRoute path={Links.Administration.link} component={Administration} />
                    <AuthenticatedRoute path={Links.MemberProfileSpecificRoute.link} component={MemberProfile} />
                    <AuthenticatedRoute path={Links.MemberProfile.link} component={MemberProfile} />
                    <Route component={Components.ErrorPage} />
                </Switch>
                <Footer />
            </BrowserRouter>
        </AuthenticationContext.Provider>
    );
}
export const TEMPLATE_PAGE_IN_CONSTRUCTION = (<h1 className="align-center mt-6">Page en construction !</h1>);
export const TEMPLATE_PAGE_NOT_AUTHORIZED = (<h1 className="align-center mt-6">Vous n'avez pas les droits d'accès à cette page</h1>);